<section>
  <div class="header-container">
    <h3>
      <mat-icon (click)="close()" class="back-btn" matTooltip="Volver atras">arrow_back</mat-icon>
      {{isEdit ? 'Editar prospecto': 'Agregar nuevo prospecto'}}
    </h3>
    <div class="button-wrap">
      <button mat-button class="success-btn" (click)="submit()"><mat-icon>save</mat-icon> {{isEdit ? 'Actualizar':
        'Crear'}}</button>
    </div>
  </div>
  <form [formGroup]="addForm">
    <div class="section">
      <div class="header-section">
        <h4>Información de contacto</h4>
        <hr>
      </div>
      <div class="row">
        <div class="col-md-6 mb-3 form-group">
          <label>Nombre comercial <span class="requiered">(*)</span></label>
          <input type="text" nbInput fullWidth fieldSize="medium" formControlName="nombre"
            placeholder="Nombre comercial">
          <p class="alert alert-danger" *ngIf="fieldRequired('nombre')">
            <span>El campo nombre comercial es requerido</span>
          </p>
          <div class="alert alert-danger" *ngIf="fieldPattern('nombre')">
            <span>No se aceptan caracteres y números</span>
          </div>
        </div>

        <div class="col-md-6 form-group">
          <label>Nombre del cliente <span class="requiered">(*)</span></label>
          <input type="text" nbInput fullWidth fieldSize="medium" formControlName="nombreCliente"
            placeholder="Nombre del cliente">
          <p class="alert alert-danger" *ngIf="fieldRequired('nombreCliente')">
            <span>El campo nombre del cliente es requerido</span>
          </p>
          <div class="alert alert-danger" *ngIf="fieldPattern('nombreCliente')">
            <span>No se aceptan caracteres y números</span>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-2">
          <label>Número de cliente <span class="requiered">(*)</span></label>
          <input type="number" (keydown)="onKeyDown($event)" nbInput fullWidth fieldSize="medium" formControlName="clientNumber"
            placeholder="Número de cliente">
          <!-- <div class="alert alert-danger" *ngIf="fieldRequired('clientNumber')">
              <span>El campo número de cliente es requerido</span>
            </div> -->
          <div class="alert alert-danger" *ngIf="fieldMin('clientNumber')">
            <span>Ingrese un número mayor a 0</span>
          </div>
        </div>
        <div class="col-md-2">
          <label>Sexo</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="gender">
            <nb-option value="male">Masculino</nb-option>
            <nb-option value="female">Femenino</nb-option>
          </nb-select>
          <!-- <div class="alert alert-danger" *ngIf="fieldRequired('gender')">
              <span>El campo sexo es requerido</span>
            </div> -->
        </div>

        <div class="col-md-2">
          <label>Edad</label>
          <input type="number" (keydown)="onKeyDown($event)" nbInput fullWidth fieldSize="medium" formControlName="age"
            placeholder="Edad">
          <!-- <div class="alert alert-danger" *ngIf="fieldRequired('age')">
              <span>El campo edad es requerido</span>
            </div> -->
          <div class="alert alert-danger" *ngIf="fieldMin('age')">
            <span>Ingrese un número mayor a 0</span>
          </div>
        </div>

        <div class="col-md-6">
          <label for="">Número de teléfono <span class="requiered">(*)</span></label>
          
          <div class="d-flex gap-2">  
            <input type="text" nbInput fieldSize="small" style="max-width: 80px;" formControlName="lada" placeholder="Lada" maxlength="3" (input)="onlyNums($event)"/>
            <input type="text" (input)="onlyNums($event)" nbInput fullWidth fieldSize="medium" formControlName="telefono"
            placeholder="Número de teléfono" maxlength="10">
          </div>
          
          <div class="alert alert-danger" *ngIf="fieldRequired('telefono')">
            <span>El campo número de teléfono es requerido</span>
          </div>
          <div class="alert alert-danger" *ngIf="fieldMinLength('telefono')">
            <span>El formato Número de telefono es incorrecto </span>
          </div>
        </div>
      </div>

      <div class="form-group row">
        <div class="col-md-6">
          <label for="">Correo electrónico <span class="requiered">(*)</span></label>
          <input type="email" nbInput fullWidth fieldSize="medium" formControlName="email"
            placeholder="Correo electrónico">
          <div class="alert alert-danger" *ngIf="fieldRequired('email')">
              <span>El campo correo electrónico es requerido</span>
            </div>
          <div class="alert alert-danger" *ngIf="fieldPattern('email')">
            <span>Ingrese un correo valido</span>
          </div>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="header-section">
        <h4>Información comercial</h4>
        <hr>
      </div>
      <div class="row">
        <div class="col-md-6 form-group">
          <label for="">Giro comercial</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="giroComercial">
            <nb-option *ngFor="let item of commercialTurn" value="{{item.value}}">{{item.viewValue |
              titlecase}}
            </nb-option>
          </nb-select>
          <div class="alert alert-danger" *ngIf="errorInComercial">
            <span>Se requiere un campo para agregar un tipo</span>
          </div>
        </div>
        <div class="col-md-6 form-group">
          <label for="">Tipo</label>
          <div class="box-tags">
            <input type="text" nbInput fullWidth fieldSize="medium" [formControl]="tagField" placeholder="Escribe...">
            <button mat-button (click)="addTag()"><mat-icon>add</mat-icon></button>
          </div>
        </div>
      </div>
      <div class="tags-container">
        <span *ngFor="let tag of tags" (click)="removeTag(tag)"><mat-icon>close</mat-icon> {{tag}}</span>
        <p *ngIf="tags.length == 0">No se han agregado etiquetas</p>
      </div>
      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Dirección comercial</label>
          <input type="text" nbInput fullWidth fieldSize="medium" formControlName="direccion" placeholder="Dirección">
        </div>

        <div class="col-md-6">
          <label for="">Origen</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="origin">
            <nb-option *ngFor="let item of origin" value="{{item.value}}">{{item.viewValue | titlecase}}
            </nb-option>
          </nb-select>
        </div>

        <!-- <div class="col-md-6">
          <label for="">Dirección fiscal</label>
          <input type="text" nbInput fullWidth fieldSize="medium" formControlName="fiscalAddress"
            placeholder="Dirección fiscal">
        </div> -->
      </div>
      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Ciudad</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="city">
            <nb-option *ngFor="let item of cities" value="{{item.value}}">{{item.viewValue | titlecase}}
            </nb-option>
          </nb-select>
        </div>
      </div>
    </div>

    <div class="section">
      <div class="header-section">
        <h4>Información de capacitación </h4>
        <hr>
      </div>
      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Vendedor</label>
          <input type="text" formControlName="vendor" nbInput fullWidth fieldSize="medium" readonly>
        </div>

        <div class="col-md-6">
          <label for="">En que requiere ayuda</label>
          <input type="text" formControlName="needHelp" nbInput fullWidth fieldSize="medium"
            placeholder="Apoyo para ...">
        </div>
        <!-- <div class="col-md-6">
          <label for="">Ejecutivos para la capacitación <span class="requiered">(*)</span></label>
          <nb-select multiple fullWidth placeholder="Selecciona una opción" formControlName="ejecutivo">
            <nb-option *ngFor="let item of executives" [value]="item.nombre">{{item.nombre | titlecase}}
            </nb-option>
          </nb-select>
          <div class="alert alert-danger" *ngIf="fieldRequired('ejecutivo')">
            <span>El campo ejecutivo asignado es requerido</span>
          </div>
        </div> -->
      </div>

      <!-- <div class="form-group row">
        <div class="col-md-6">
          <label for="">Fecha de capacitación <span class="requiered">(*)</span></label>
          <input matInput [matDatepicker]="picker" placeholder="Seleccione una fecha" formControlName="trainingDate"
            (click)="picker.open()">
          <mat-datepicker #picker></mat-datepicker>

          <div class="alert alert-danger" *ngIf="fieldRequired('trainingDate')">
            <span>El campo fecha de capacitación es requerido</span>
          </div>
        </div>
        <div class="col-md-6">
          <div class="timeSelect">
            <label for="">Hora de capacitación <span class="requiered">(*)</span></label>
            <ngb-timepicker formControlName="trainingHour" [hourStep]="1" [minuteStep]="15"></ngb-timepicker>
          </div>
          <div class="alert alert-danger" *ngIf="fieldRequired('trainingHour')">
            <span>El campo hora de capacitación es requerido</span>
          </div>
        </div>
      </div> -->

      <div class="form-group row">
        <!-- <div class="col-md-6">
          <label for="">Link de Zoom</label>
          <input type="text" formControlName="zoomLink" nbInput fullWidth fieldSize="medium"
            placeholder="https://us06web.zoom.us...">
        </div> -->
        
      </div>
    </div>

    <div class="section">
      <div class="header-section">
        <h4>Información de contrato</h4>
        <hr>
      </div>
      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Plan contratado</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="plan">
            <nb-option *ngFor="let item of actualPlans" [value]="item.title">{{item.title | titlecase}}
            </nb-option>
          </nb-select>
        </div>

        <div class="col-md-6">
          <label for="">Campaña</label>
          <input type="text" nbInput fullWidth fieldSize="medium" formControlName="campaign" placeholder="Campaña">
        </div>
      </div>

      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Promoción aplicada</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="promotion">
            <nb-option *ngFor="let item of promotion" value="{{item.value}}">{{item.viewValue | titlecase}}
            </nb-option>
          </nb-select>
        </div>

        <div class="col-md-6">
          <label for="">Requiere Factura</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="invoice">
            <nb-option value="Si">Si</nb-option>
            <nb-option value="No">No</nb-option>
          </nb-select>
        </div>
      </div>
      <div class=" form-group row">
        <div class="col-md-6">
          <label for="">Pagado</label>
          <nb-select fullWidth placeholder="Selecciona una opción" formControlName="isPaid">
            <nb-option value="Si">Si</nb-option>
            <nb-option value="No">No</nb-option>
          </nb-select>
        </div>
      </div>
    </div>

  </form>

  <div class="loading-overlay" *ngIf="isLoading">

    <nb-card class="loading-card">
      <nb-card-header>
        <h4>Buscando número de cliente...</h4>
      </nb-card-header>

      <nb-card-body class="text-center">

        <small>
          Espere un momento mientras se obtiene el siguiente número disponible.
        </small>

        <div class="loader loader--style1 mt-3">
          <svg version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            width="40px"
            height="40px"
            viewBox="0 0 40 40">

            <path opacity="0.2" fill="#000"
              d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946
              c0,8.255,6.692,14.946,14.946,14.946
              s14.946-6.691,14.946-14.946
              C35.146,11.861,28.455,5.169,20.201,5.169z" />

            <path fill="#000"
              d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0
              C22.32,8.481,24.301,9.057,26.013,10.047z">

              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 20 20"
                to="360 20 20"
                dur="0.5s"
                repeatCount="indefinite" />

            </path>

          </svg>
        </div>

      </nb-card-body>
    </nb-card>

  </div>
</section>